import React from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';
import { style } from './styles';

export type CustomMessage = {
  openModal: boolean;
  message?: string;
  title?: string;
};

type PropTypes = {
  customMessage: CustomMessage;
  handleCustomMessageSubmit: () => void;
  setCustomMessage: ({ openModal }: CustomMessage) => void;
};

export const CustomMessageModal = ({
  customMessage,
  handleCustomMessageSubmit,
  setCustomMessage,
}: PropTypes) => {
  const { openModal, message, title } = customMessage;
  return (
    <Modal
      open={openModal}
      onClose={() => setCustomMessage({ openModal: false, message, title })}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h5" component="h2">
          {title || 'Hmm...'}
        </Typography>
        <Typography id="modal-modal-title" mt={2}>
          {message}
        </Typography>
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCustomMessageSubmit}
            sx={{ mt: 2 }}
          >
            Ok
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
